import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['profileImageFileInput', 'profileImageSubmitButton'];

  connect() {
    this.profileImageFileInputTarget.addEventListener(
      'change',
      this.handleProfileImageFileChoosen.bind(this)
    );
  }

  chooseFileForProfileImage(event) {
    event.preventDefault();
    this.profileImageFileInputTarget.click();
  }

  handleProfileImageFileChoosen() {
    this.profileImageSubmitButtonTarget.click();
  }
}
